<template>
  <div>
    <!-- 未绑定手机号 -->
    <div class="container bind">
      <div class="bindPhone flex-col flex-jc-bt">
        <div class="content">
          <h1>{{ texts.title }}</h1>
          <h5 v-if="!valid">每个手机号只能绑定一个账号</h5>
          <div class="form">
            <div class="">
              <div class="form-item flex-row flex-al-center">
                <img
                  src="https://img.yzcdn.cn/upload_files/2020/01/08/Fvm798nVjIXwrf9RqCI5x3SaO2E3.png"
                 
                />
                <input
                  v-model="mobileText"
                  type="text"
                  placeholder="请输入要更换的手机号"
                  :disabled="valid"
                />
              </div>
              <div class="form-item flex-row flex-al-center" style="margin-top: 0.35rem;">
                <img
                  src="https://img.yzcdn.cn/upload_files/2020/01/08/FjJDgygf16b1l62oQbIKhGpLFSzx.png"
                 
                />
                <input v-model="code" type="text" placeholder="请输入验证码" />
                <van-button
                  round
                  type="info"
                  class="postCode flex-center"
                  :class="canSendCode && 'canClick'"
                  :disabled="!canSendCode"
                  @click="sendCode"
                >
                  <span>{{ textCodeLoding }}</span>
                </van-button>
              </div>
            </div>
          </div>
          <div class="button__box">
            <van-button
              round
              type="info"
              size="large"
              class="submit flex-center"
              :class="canSubmit && 'canSubmit'"
              :loading="!enabledSubmit"
              loading-text="验证中..."
              :disabled="!canSubmit"
              @click="submit"
            >
              <span>立即验证</span>
            </van-button>
          </div>
        </div>
        <div class="footer">
          点击立即验证，即表示同意
          <a href="/cms/webapp/home/info/privacy.html">《乐子用户服务及隐私协议》</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkKaptcha, sendSMSAdd } from '@/pages/userCenter/bind-phone-number/api'
export default {
  data() {
    return {
      mobile: '',
      mobileText: '',
      code: '',
      enabledSubmit: true,
      enabledSendCode: true,
      textCodeLoding: '获取验证码',
      valid: false // 是否是验证手机号
    }
  },
  computed: {
    verifyMobileText() {
      return !!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobileText)
    },
    verifyCode() {
      return !!/^\d{4}$/.test(this.code)
    },
    canSendCode() {
      return this.verifyMobileText && this.enabledSendCode
    },
    canSubmit() {
      return this.verifyMobileText && this.verifyCode && this.enabledSubmit
    },
    texts() {
      return {
        title: '更换手机号'
      }
    }
  },
  mounted() {
    this.valid = this.$route.name === 'verifyPhoneNumber'
    this.mobile = this.$store.userInfo.mobile
    if (!this.valid && !this.$route.query.bind && this.mobile) {
      this.gotoSuccessRoute()
    } else {
      if (!this.$route.query.bind) this.mobileText = this.mobile
    }
  },
  methods: {
    // 点击立即验证
    submit() {
      const mobileText = this.mobileText
      // 防止重复点击
      if (!this.enabledSubmit) return
      this.enabledSubmit = false
      sendSMSAdd({
        openid: this.$store.openid,
        phone: this.mobileText,
        code: this.code
      }).then(({ code, msg, isSendBasicService }) => {

        if (code !== 200) {
          this.$toast(msg)
          this.enabledSubmit = true
        } else {
          // 将$store中的数据
          this.$store.userInfo.mobile = mobileText
          this.$store.commit('user/UPDATE_USER_MOBILE_NUMBER', mobileText)
          if (this.$route.query.jifen === '1') {
            this.$router.push({ path: '/IntegralGraphic?phone=' + mobileText + '&channel' + this.$route.query.channel + '&id=' + this.$route.query.id })
          }
        }
      }).catch(e => {
        this.$toast('绑定失败')
        this.enabledSubmit = true
      })
    },
    // 发送验证码
    async sendCode() {
      // 防止重复点击
      if (!this.enabledSendCode) return
      this.enabledSendCode = false
      const { remainingSecond, code, msg } = await checkKaptcha({
        openid: this.$store.openid,
        phone: this.mobileText
      })
      if (code !== 200 || remainingSecond === -1) {
        this.$toast(msg)
        this.enabledSendCode = true
        return
      }
      // remainingSecond为0表示发送成功, 如果remainingSecond>0则表示刚刚发送过验证码
      let countdown = remainingSecond <= 0 ? 60 : remainingSecond
      this.textCodeLoding = `${--countdown}s重新验证`
      this.codeInterval = setInterval(() => {
        if (countdown === 0) {
          this.textCodeLoding = '获取验证码'
          this.enabledSendCode = true
          clearInterval(this.codeInterval)
        } else {
          this.textCodeLoding = `${--countdown}s重新验证`
        }
      }, 1000)
    },
    gotoSuccessRoute(type) {
      this.$router.replace({
        name: 'bindPhoneNumberSuccess',
        params: {
          type: type || 0
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.container {
  border-top: 0.18rem solid #f4f4f4;
  min-height: 100vh;
  background: #fff;
}
.bind {
  .bindPhone {
    background-color: #ffffff;
    padding: 2.15rem 0.8rem 0.79rem 0.8rem;
    min-height: calc(100vh - 0.18rem);
  }

  .content h1 {
    font-size: 0.8rem;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .content h5 {
    margin-top: 0.4rem;
    font-size: 0.43rem;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
    line-height: 0.53rem;
  }

  .form {
    margin-top: 1.5rem;
  }

  .form-item {
    padding: 0.31rem 0;
    border-bottom: 1px solid rgba(234, 234, 234, 1);
    position: relative;
  }

  .form-item input {
    font-size: 0.43rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }

  .form-item input::placeholder {
    color: rgba(195, 195, 195, 1);
  }

  .form-item img {
    display: block;
    width: 0.4rem;
    height: 100%;
    margin-right: 0.32rem;
  }

  .postCode {
    position: absolute;
    padding: 0;
    right: 0;
    width: 2.64rem;
    height: 0.85rem;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(234, 234, 234, 1);
    border-radius: 0.43rem;
    font-size: 0.37rem;
    font-weight: 400;
    color: rgba(195, 195, 195, 1);
  }

  .form-item .canClick {
    background: rgba(239, 66, 70, 1);
    color: rgba(255, 255, 255, 1);
  }
  .button__box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 1.31rem;
  }
  .submit {
    border: none;
    width: 7.36rem;
    height: 1.23rem;
    background: rgba(221, 221, 221, 1);
    box-shadow: 0px 3px 9px 1px rgba(221, 221, 221, 0.5);
    border-radius: 1rem;
    font-size: 0.43rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .canSubmit {
    background: #ef4246;
    box-shadow: 0px 3px 9px 1px rgba(239, 66, 70, 0.5);
  }

  .footer {
    font-size: 0.32rem;
    font-weight: 400;
    color: rgba(164, 164, 164, 1);
    line-height: 0.53rem;
    text-align: center;
  }

  .footer a {
    color: #ef4246;
  }
}
</style>
